module.exports = "/_next/static/images/home-banner.vn-89e528042d9b1414f754eb6372dce357.svg";